import React from 'react';
import BaseKeyNumberGrid from './BaseKeyNumberGrid';
import { useTreeData } from 'utils/hooks/useTreeData';

const TonnageKeyNumber = ({ rows, columns }) => {
  const { processedColumns, processedRows } = useTreeData(rows, columns);

  return <BaseKeyNumberGrid rows={processedRows} columns={processedColumns} />;
};

export default TonnageKeyNumber;
